'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _cartIconSVG = require('./cartIconSVG.js');

var _cartIconSVG2 = _interopRequireDefault(_cartIconSVG);

var _index = require('../../utils/index');

var _wixSdkOOI = require('./wixSdkOOI');

var _wixSdkOOI2 = _interopRequireDefault(_wixSdkOOI);

var _artstorePageManager = require('../../applications/gallery/artstorePageManager');

var _artstorePageManager2 = _interopRequireDefault(_artstorePageManager);

var _consts = require('../consts');

var _translationUtils = require('@wix/photography-client-lib/dist/src/utils/translationUtils');

var _translationUtils2 = _interopRequireDefault(_translationUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CartIcon = function (_Component) {
  (0, _inherits3.default)(CartIcon, _Component);

  function CartIcon(props) {
    (0, _classCallCheck3.default)(this, CartIcon);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CartIcon.__proto__ || (0, _getPrototypeOf2.default)(CartIcon)).call(this, props));

    _this.state = {
      ready: false
    };
    return _this;
  }

  (0, _createClass3.default)(CartIcon, [{
    key: 'initCartState',
    value: function initCartState(props) {
      var _getCartIconStyles = this.getCartIconStyles(props.styleParams),
          cartIcon = _getCartIconStyles.cartIcon,
          cartIconColor = _getCartIconStyles.cartIconColor;

      var COMPONENT = props.publicData.COMPONENT;

      var cartIconText = COMPONENT && COMPONENT.cartIconText;
      this.setState({
        cartIcon: cartIcon,
        cartIconColor: cartIconColor,
        cartIconText: cartIconText,
        ready: true
      });
    }
  }, {
    key: 'getCartIconStyles',
    value: function getCartIconStyles(_ref) {
      var numbers = _ref.numbers,
          colors = _ref.colors;

      var color8 = void 0;
      try {
        color8 = this.props.host.style.siteColors.find(function (color) {
          return color.reference === 'color-8';
        }).value;
      } catch (e) {
        color8 = '#384AD3'; //defualt color 8
      }
      var icons = ['cart', 'cartOutline', 'bag', 'bagOutline', 'cartText'];
      var getIconColor = function getIconColor(param) {
        return param && param.value || color8;
      };
      var getCartIcon = function getCartIcon(num) {
        return num >= 0 ? icons[num] : icons[3];
      };
      var cartIcon = getCartIcon(Number(numbers.cartIcon));
      var cartIconColor = getIconColor(colors.cartIconColor);
      return { cartIcon: cartIcon, cartIconColor: cartIconColor };
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(e) {
      switch (e.keyCode || e.charCode) {
        case 32: //space
        case 13:
          //enter
          e.preventDefault();
          e.stopPropagation();
          this.props.changeStoreFrameState(_consts.ARTSTORE_PUBSUB_ENUMS.CART, true);
          return false;
        default:
          break;
      }
      return true;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (!this.state.ready && newProps.ready) {
        this.initCartState(newProps);
      }
    }
  }, {
    key: 'init',
    value: function init() {
      this.props.tryToReportAppLoaded();
      if (!this.wixSdk) {
        var _props = this.props,
            baseUrl = _props.baseUrl,
            sectionsUrls = _props.sectionsUrls,
            visitorId = _props.visitorId,
            metaSiteId = _props.metaSiteId,
            locale = _props.locale,
            _props$host = _props.host,
            formFactor = _props$host.formFactor,
            style = _props$host.style;

        var getDeviceType = function getDeviceType(type) {
          return type === 'mobile' || type === 'tablet' ? 'mobile' : 'desktop';
        };
        this.wixSdk = (0, _wixSdkOOI2.default)({ baseUrl: baseUrl, sectionsUrls: sectionsUrls, visitorId: visitorId, metaSiteId: metaSiteId, locale: locale, deviceType: getDeviceType(formFactor.toLowerCase()), style: style });
      }
      if (!this.pageManager) {
        var _props$props$host = (0, _extends3.default)({}, this.props, this.props.host),
            _locale = _props$props$host.locale,
            _formFactor = _props$props$host.formFactor,
            connectedProviders = _props$props$host.connectedProviders,
            viewMode = _props$props$host.viewMode;

        this.pageManager = new _artstorePageManager2.default({
          isMobile: _index.utils.isMobile(),
          viewMode: viewMode.toLowerCase(),
          connectedProviders: connectedProviders,
          locale: _locale,
          deviceType: _formFactor.toLowerCase()
        });
      }
      if (!this.translations && this.props.translations) {
        _translationUtils2.default.setTranslations(this.props.translations);
        this.translations = this.props.translations;
      }
    }
  }, {
    key: 'openCart',
    value: function openCart() {
      var _props2 = this.props,
          changeStoreFrameState = _props2.changeStoreFrameState,
          galleryWidgetActive = _props2.galleryWidgetActive,
          storeApi = _props2.storeApi;

      galleryWidgetActive ? storeApi.showCart() : changeStoreFrameState(_consts.ARTSTORE_PUBSUB_ENUMS.CART, true);
    }
  }, {
    key: 'getCartIconElement',
    value: function getCartIconElement() {
      var _this2 = this;

      var _state = this.state,
          cartIcon = _state.cartIcon,
          cartIconText = _state.cartIconText,
          cartIconColor = _state.cartIconColor;
      var _props3 = this.props,
          _props3$host$dimensio = _props3.host.dimensions,
          width = _props3$host$dimensio.width,
          height = _props3$host$dimensio.height,
          cartItemsCount = _props3.cartItemsData.cartItemsCount;

      var count = cartItemsCount || 0;
      var cartCount = cartIcon === 'cartText' ? '(' + count + ')' : count;
      return _react2.default.createElement(
        'div',
        {
          onClick: function onClick() {
            return _this2.openCart();
          },
          onKeyDown: this.handleKeyDown,
          'aria-label': 'Cart (' + cartCount + ')',
          role: 'button',
          style: { width: width, height: height },
          className: 'artstore-cart-icon'
        },
        _react2.default.createElement(
          'div',
          { className: 'artstore-cart-icon-svg-container' },
          cartIcon === 'cartText' ? _react2.default.createElement(
            'div',
            null,
            cartIconText
          ) : _react2.default.createElement(_cartIconSVG2.default, { icon: cartIcon, color: cartIconColor })
        ),
        _react2.default.createElement(
          'div',
          { className: 'artstore-cart-icon-count' },
          cartCount
        )
      );
    }
  }, {
    key: 'getPagesData',
    value: function getPagesData() {
      var _props4 = this.props,
          cartItemsData = _props4.cartItemsData,
          additionalProviderParams = _props4.additionalProviderParams,
          checkoutParams = _props4.checkoutParams,
          changeStoreFrameState = _props4.changeStoreFrameState,
          storeApi = _props4.storeApi;

      var wixSdk = this.wixSdk;
      return (0, _extends3.default)({}, cartItemsData, {
        additionalProviderParams: additionalProviderParams,
        wixSdk: wixSdk,
        changeStoreFrameState: changeStoreFrameState,
        checkoutParams: checkoutParams,
        storeApi: storeApi
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props5 = this.props,
          connectedProviders = _props5.connectedProviders,
          pagesState = _props5.pagesState,
          galleryWidgetActive = _props5.galleryWidgetActive,
          additionalProviderParams = _props5.additionalProviderParams;

      var hideCartIcon = additionalProviderParams && additionalProviderParams.freeArtStore;
      if (!connectedProviders || !this.state.ready || hideCartIcon) {
        return null;
      }
      this.init();
      var dom = [this.getCartIconElement()];
      if (!galleryWidgetActive) {
        //art store cart,checkout and editor from cart widget is active only when no gallery widget on page
        var pageData = this.getPagesData();
        dom.push(this.pageManager.getPages(pageData, pagesState, 'cart'));
      }
      return _react2.default.createElement(
        'div',
        null,
        dom
      );
    }
  }]);
  return CartIcon;
}(_react.Component);

exports.default = CartIcon;